function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M20.56,1.75H17.5V.44A.44.44,0,0,0,17.06,0H14.44A.44.44,0,0,0,14,.44V1.75H7V.44A.44.44,0,0,0,6.56,0H3.94A.44.44,0,0,0,3.5.44V1.75H.44A.44.44,0,0,0,0,2.19V20.56A.44.44,0,0,0,.44,21H20.56a.44.44,0,0,0,.44-.44V2.19A.44.44,0,0,0,20.56,1.75ZM14.88.88h1.74V3.5H14.88ZM4.38.88H6.12V3.5H4.38ZM3.5,2.62V3.94a.44.44,0,0,0,.44.44H6.56A.44.44,0,0,0,7,3.94V2.62h7V3.94a.44.44,0,0,0,.44.44h2.62a.44.44,0,0,0,.44-.44V2.62h2.62v3.5H.88V2.62ZM.88,20.12V7H20.12V20.12ZM18.81,10.5a.44.44,0,1,0,0-.88H14.88V8.31a.44.44,0,0,0-.88,0V9.62H10.5V8.31a.44.44,0,0,0-.88,0V9.62H6.12V8.31a.43.43,0,0,0-.43-.43.44.44,0,0,0-.44.43V9.62H2.19a.44.44,0,0,0,0,.88H5.25v2.62H2.19a.44.44,0,0,0,0,.88H5.25v2.62H2.19a.44.44,0,0,0,0,.88H5.25v1.31a.44.44,0,0,0,.44.44.44.44,0,0,0,.43-.44V17.5h3.5v1.31a.44.44,0,1,0,.88,0V17.5H14v1.31a.44.44,0,1,0,.88,0V17.5h3.93a.44.44,0,1,0,0-.88H14.88V14h3.93a.44.44,0,1,0,0-.88H14.88V10.5Zm-12.69,0h3.5v2.62H6.12Zm0,6.12V14h3.5v2.62Zm7.88,0H10.5V14H14Zm0-3.5H10.5V10.5H14Z"
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.0f1eff38.svg";
export { ForwardRef as ReactComponent };